'use strict';

var accentColors = require('../../../../../../../../../_virtual/accentColors.cjs');

var hasRequiredAccentColors;

function requireAccentColors () {
	if (hasRequiredAccentColors) return accentColors.__exports;
	hasRequiredAccentColors = 1;

	var AVIARY_ACCENTS = /*#__PURE__*/ function(AVIARY_ACCENTS) {
	    AVIARY_ACCENTS["forest"] = "forest";
	    AVIARY_ACCENTS["sand"] = "sand";
	    return AVIARY_ACCENTS;
	}({});

	accentColors.__exports.AVIARY_ACCENTS = AVIARY_ACCENTS;
	
	return accentColors.__exports;
}

exports.__require = requireAccentColors;
//# sourceMappingURL=accentColors.cjs.map
